var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrow4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 116,
    viewBox: "0 0 115 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_112_41)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.993 0H7.84663C3.51306 0 0 3.51306 0 7.84663V107.588C0 111.922 3.51306 115.435 7.84663 115.435H106.993C111.327 115.435 114.84 111.922 114.84 107.588V7.84663C114.84 3.51306 111.327 0 106.993 0Z",
    fill: "#EBF9F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6896 91.394C60.7212 83.3624 60.7212 70.3407 52.6896 62.3091C44.6581 54.2775 31.6363 54.2775 23.6047 62.3091C15.5732 70.3407 15.5732 83.3624 23.6048 91.394C31.6363 99.4256 44.6581 99.4256 52.6896 91.394Z",
    stroke: "#32BFBD",
    strokeWidth: 3.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2125 63.1648C35.4626 62.806 36.783 62.6133 38.1484 62.6133C46.0121 62.6133 52.3867 68.9879 52.3867 76.8516C52.3867 84.7152 46.0121 91.0898 38.1484 91.0898C30.2848 91.0898 23.9102 84.7152 23.9102 76.8516C23.9102 75.4866 24.1027 74.1665 24.4612 72.9167",
    stroke: "#32BFBD",
    strokeWidth: 3.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7612 67.8389V81.5981C82.7612 83.3383 81.3374 84.7622 79.5971 84.7622H66.6289",
    stroke: "#32BFBD",
    strokeWidth: 3.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2383 49.1616V35.4023C30.2383 33.6621 31.6621 32.2383 33.4023 32.2383H46.3706",
    stroke: "#32BFBD",
    strokeWidth: 3.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0177 58.559C81.1702 59.9768 78.0326 60.7147 74.8515 60.7147C63.493 60.7147 54.2852 51.5068 54.2852 40.1484C54.2852 28.7899 63.493 19.582 74.8515 19.582C86.2099 19.582 95.4178 28.7899 95.4178 40.1484C95.4178 44.9734 93.7214 49.6448 90.6252 53.3455",
    stroke: "#32BFBD",
    strokeWidth: 3.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1484 36.5357C67.6011 30.9673 75.2075 35.0087 71.3207 39.3277C69.6577 41.1756 66.7257 44.3242 66.1484 46.4765H72.4766",
    stroke: "#32BFBD",
    strokeWidth: 3.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7607 40.939H77.2227L78.0129 33.8203M83.5511 33.8203V46.4766",
    stroke: "#32BFBD",
    strokeWidth: 3.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0939 54.036L89.3932 54.6909L88.7383 49.9902",
    stroke: "#32BFBD",
    strokeWidth: 3.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0781 66.784L28.0789 66.7832",
    stroke: "#32BFBD",
    strokeWidth: 3.5,
    strokeMiterlimit: 2.6131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_112_41",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 65,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 65,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_112_41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.0252 86V83.85C36.1419 83.65 35.3794 83.2667 34.7377 82.7C34.096 82.1333 33.6252 81.3333 33.3252 80.3L35.1752 79.55C35.4252 80.35 35.796 80.9583 36.2877 81.375C36.7794 81.7917 37.4252 82 38.2252 82C38.9085 82 39.4877 81.8458 39.9627 81.5375C40.4377 81.2292 40.6752 80.75 40.6752 80.1C40.6752 79.5167 40.4919 79.0542 40.1252 78.7125C39.7585 78.3708 38.9085 77.9833 37.5752 77.55C36.1419 77.1 35.1585 76.5625 34.6252 75.9375C34.0919 75.3125 33.8252 74.55 33.8252 73.65C33.8252 72.5667 34.1752 71.725 34.8752 71.125C35.5752 70.525 36.2919 70.1833 37.0252 70.1V68H39.0252V70.1C39.8585 70.2333 40.546 70.5375 41.0877 71.0125C41.6294 71.4875 42.0252 72.0667 42.2752 72.75L40.4252 73.55C40.2252 73.0167 39.9419 72.6167 39.5752 72.35C39.2085 72.0833 38.7085 71.95 38.0752 71.95C37.3419 71.95 36.7835 72.1125 36.4002 72.4375C36.0169 72.7625 35.8252 73.1667 35.8252 73.65C35.8252 74.2 36.0752 74.6333 36.5752 74.95C37.0752 75.2667 37.9419 75.6 39.1752 75.95C40.3252 76.2833 41.196 76.8125 41.7877 77.5375C42.3794 78.2625 42.6752 79.1 42.6752 80.05C42.6752 81.2333 42.3252 82.1333 41.6252 82.75C40.9252 83.3667 40.0585 83.75 39.0252 83.9V86H37.0252Z",
    fill: "#32BFBD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_41"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 116,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrow4);
export default __webpack_public_path__ + "static/media/grow4.c97781bb58a3deb7192d5310c4dbfdc3.svg";
export { ForwardRef as ReactComponent };